import { CLEAR_NAMED_PARTY_SEARCH_CRITERIA } from '../types';

const resetSearchCriteria = () => {
  return {
    type: CLEAR_NAMED_PARTY_SEARCH_CRITERIA,
    payload: {
      CaseNames: [],
      States: [],
      Issues: [],
      Statuses: [],
    },
  };
};

export default () => {
  return async dispatch => {
    await dispatch(resetSearchCriteria());
  };
};
